import {createSlice, type SliceSelectors, type SliceCaseReducers} from '@reduxjs/toolkit'

import {getTradeAccountInfoByDetail} from '@web/actions/detail'
import {getBankName} from '@web/helpers/policies'
import {changeVirtualAccountBank, AdmissionDetailState, getInitialState} from '@web/slices/admissionDetail/slice'

import {AdmissionDetailReducers, MakeCreateSliceOptions} from './interface'

type Reducers = SliceCaseReducers<AdmissionDetailState>

const slice = (options?: MakeCreateSliceOptions) =>
    createSlice<AdmissionDetailState, Reducers, 'admissionDetail', SliceSelectors<AdmissionDetailState>>({
        name: 'admissionDetail',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(getTradeAccountInfoByDetail.fulfilled, (state, {payload}) => {
                    if (state.usedPaymentMethod.account) {
                        state.usedPaymentMethod.account.trade = {
                            naverFinancial: {
                                bankName: payload.naverFinancialBankName,
                                maskedAccountNo: payload.naverFinancialMaskedAccountNo,
                            },
                            purchaser: {
                                bankName: payload.purchaserBankName,
                                maskedAccountNo: payload.purchaserMaskedAccountNo,
                            },
                        }
                    }
                })
                .addCase(changeVirtualAccountBank.fulfilled, (state, {payload}) => {
                    if (state.usedPaymentMethod.virtualAccount) {
                        state.usedPaymentMethod.virtualAccount.virtualAccountBankCode = payload.bankCode
                        state.usedPaymentMethod.virtualAccount.virtualAccountBankName = getBankName(payload.bankCode)
                        state.usedPaymentMethod.virtualAccount.virtualAccountNo = payload.accountNo
                    }
                })
            options?.extraReducers?.(builder)
        },
    })

/**
 * TODO: admission-detail이 36번 라인으로 slice를 만든 결과물을 내보내기 때문에 pages에서 자체적으로 reducer 등록을 할 수 없음
 * 아래 방향으로 바꾸면 어떨지...
 */
export const makeSlice = (options?: MakeCreateSliceOptions) =>
    createSlice<AdmissionDetailState, AdmissionDetailReducers, 'admissionDetail', SliceSelectors<AdmissionDetailState>>(
        {
            name: 'admissionDetail',
            initialState: getInitialState(),
            reducers: {},
            extraReducers: (builder) => {
                options?.extraReducers?.(builder)
            },
        },
    )

export default slice
